import './card-login.scss';

export default () => {

};
